import axios from "axios";
import {getField, updateField} from "vuex-map-fields";
import i18n from "@/i18n";


export default {
  namespaced: true,
  state: {
    savingInProgress: false,
    fetched: false,
    importFiles: [],
    importFile: {
      id: null,
      file: null,
      filename: null,
      extension: null,
      storage: null,
      rack: null,
      shelve: null,
    },
    search:null,
    goods: [],
    goodsTotal: null,
    tableOptions: {
      page: 1,
      last_page: 1,
      itemsPerPage: 15,
      sortBy: ["id"],
      sortDesc: [true],
      groupBy: [],
      groupDesc: [],
      mustSort: false,
      multiSort: false,
    },
    oneGoods: {
      amount:  null,
      min_amount: null,
      brand:  null,
      id:  null,
      name:  null,
      price:  null,
      rack:  null,
      shelf:  null,
      storage: null,
      nomenclature:{
          brand:  null,
          name:  null,
          part_code:  null,
      }
    },
  },
  getters:{
    getField, //vuex-map-fields
  },
  mutations: {
    addOneGoodToState(state, data){
      let object = state.goods;
      object.unshift(data);
      updateField(state, {path:'goods', value:object});
      state = {...state}
    },
    updateOneGoodInState(state, data){
      let object = state.goods;
      object = object.map((item)=>{
        if(item.id===data.id) item = data;
        return item;
      })
      updateField(state, {path:'goods', value:object});
      state = {...state}
    },
    updateField, //vuex-map-fields
  },
  actions: {
    async partsGet({ commit, state, dispatch }, payload) {
      commit("updatePartsLoader", true);
      return await axios
          .post(this._vm.$apiURL + "/suppliers/api", {
            method: "parts",
            data: { part_code: payload.part_code, brand: payload.brand },
          })
          .then((response) => {
            if (response.data.error) {
              if (error.response.data.errors) {
                this._vm.$error(
                    Object.entries(error.response.data.errors)[0][1][0]
                );
              } else {
                this._vm.$error(error.response.statusText);
              }
            } else {
              commit("updatePartsData", response.data.data || []);
              commit("updatePartsStats", response.data.stats || null);
            }
          })
          .catch((error) => {
            dispatch("common/showError", { error: error }, { root: true });
            state.loaderBrandsGet = false;
          })
          .finally(() => {
            commit("updatePartsLoader", false);
          });
    },
    importFileSave({ commit, state, dispatch }){
      updateField(state, {path:'savingInProgress', value:true});
      let formData = new FormData();
      for ( let key in state.importFile ) {
        if(typeof state.importFile[key] === 'object' && key !='file' ) {
          formData.append(key, JSON.stringify(state.importFile[key]));
        } else {
          formData.append(key, state.importFile[key]);
        }
      }
      return axios.post(this._vm.$apiURL + '/goods_import_file', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }}
      )
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t('common.success_add'));
          return response.data;
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root:true});
        })
        .finally(()=>{
          updateField(state, {path:'savingInProgress', value:false});
        })
    },
    getFiles({ commit, state, dispatch }, payload){
        updateField(state, {path:'fetched', value:true});
        axios.get(this._vm.$apiURL + '/goods_import_file')
            .then((response) => {
                updateField(state, {path:'importFiles', value:response.data});
            })
            .catch((error) => {
                dispatch('common/showError', {'error': error}, {root:true});
            })
    },
    one_goods_save({ commit, state, dispatch }, payload){
      updateField(state, {path:'savingInProgress', value:true});
      return axios[(payload.id) ? 'put' : 'post'](this._vm.$apiURL + '/goods'+(payload.id ? `/${payload.id}` : ''), payload)
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t('common.operation_success'));
          if(!payload.id && response.data.one_goods){
            commit('addOneGoodToState', response.data.one_goods);
          } else {
            commit('updateOneGoodInState', response.data.one_goods);
            //dispatch('get');
          }
          return response.data;
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root:true});
        })
        .finally(()=>{
          updateField(state, {path:'savingInProgress', value:false});
        })
    },
    async remove({ commit, state, dispatch }, payload){
      updateField(state, {path:'savingInProgress', value:false});
      return await this._vm.$confirm( {
        title : this._vm.i18n.t('common.confirm'),
        text : this._vm.i18n.t('common.confirm_remove'),
        cancelText : this._vm.i18n.t('common.no'),
        acceptText : this._vm.i18n.t('common.yes')
      } )
        .then( async y =>{
          return await axios.delete(this._vm.$apiURL+'/goods/'+payload)
            .then(response => {
              if(response.data.status==='success'){
                this._vm.$inform( this._vm.i18n.t('common.success_remove') )
                return true;
              }
            })
            .catch(error => {
              dispatch('common/showError', {'error': error}, {root:true});
            })
            .finally(()=>{
              updateField(state, {path:'savingInProgress', value:false});
            })
        })
        .catch( n => {} )
        .finally(()=>{
          updateField(state, {path:'savingInProgress', value:false});
        })
    },
    async get({ commit, state, dispatch }, payload){
      updateField(state, {path:'fetched', value:false});
      if(state.search!==null && state.search.length>0) {
        updateField(state, {
          path: "tableOptions.page",
          value: parseInt(1),
        });
      }
      return await axios.get(`${this._vm.$apiURL}/goods`,{
        params: {
          storages:payload.storages ? payload.storages.join(',') : '',
          page: state.tableOptions.page,
          find_string: state.search,
          itemsPerPage: state.tableOptions.itemsPerPage,
          sortBy: state.tableOptions.sortBy[0],
          sortDesc: state.tableOptions.sortDesc[0],
        }})
        .then((response) => {
          updateField(state, {
            path: "goodsTotal",
            value: parseInt(response.data.total),
          });
          updateField(state, {path: "goods", value: response.data.data});
          updateField(state, {
            path: "tableOptions.page",
            value: parseInt(response.data.current_page),
          });
          updateField(state, {
            path: "tableOptions.last_page",
            value: parseInt(response.data.last_page),
          });
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root:true});
        })
        .finally(()=>{
          updateField(state, {path:'fetched', value:true});
        })
    },
  }
}
